export enum BANK_STATEMENT_TYPES {
  Sale = 1,
  Purchase = 2,
}
